
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class DsaReaderService {

   public static getDsaAgentDashboardData(
           axiosInstance: AxiosInstance, input: ServerData.DsaWebReader.GetDsaAgentDashboardData$Input,
           f: (output: ServerData.DsaWebReader.GetDsaAgentDashboardData$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'partnerprogramapi/dsa/get-dsa-agent-dashboard-data',
            {params : input.toJson()}
        ).then((response) => ServerData.DsaWebReader.GetDsaAgentDashboardData$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getDsaAgentPerformanceData(
           axiosInstance: AxiosInstance, input: ServerData.DsaWebReader.GetDsaAgentPerformanceData$Input,
           f: (output: ServerData.DsaWebReader.GetDsaAgentPerformanceData$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'partnerprogramapi/dsa/get-dsa-agent-performance-data',
            {params : input.toJson()}
        ).then((response) => ServerData.DsaWebReader.GetDsaAgentPerformanceData$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getDsaLeadDashboardData(
           axiosInstance: AxiosInstance, input: ServerData.DsaWebReader.GetDsaLeadDashboardData$Input,
           f: (output: ServerData.DsaWebReader.GetDsaLeadDashboardData$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'partnerprogramapi/dsa/get-dsa-lead-dashboard-data',
            {params : input.toJson()}
        ).then((response) => ServerData.DsaWebReader.GetDsaLeadDashboardData$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static getDsaLeadPerformanceData(
           axiosInstance: AxiosInstance, input: ServerData.DsaWebReader.GetDsaLeadPerformanceData$Input,
           f: (output: ServerData.DsaWebReader.GetDsaLeadPerformanceData$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'partnerprogramapi/dsa/get-dsa-lead-performance-data',
            {params : input.toJson()}
        ).then((response) => ServerData.DsaWebReader.GetDsaLeadPerformanceData$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

